import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Companion_getInstancek3kgntyryryj as Companion_getInstance } from '../../../../../ktor-ktor-http/io/ktor/http/HttpStatusCode.mjs';
import {
  Send_instance2se4t9sd7p3bp as Send_instance,
  Sender1wtdgti85uk42 as Sender,
} from './api/CommonHooks.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_authority2s3hk87lssumy as get_authority } from '../../../../../ktor-ktor-http/io/ktor/http/Url.mjs';
import { HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder } from '../request/HttpRequest.mjs';
import { takeFrom3rd40szpqy350 as takeFrom } from '../../../../../ktor-ktor-http/io/ktor/http/URLParser.mjs';
import { isSecurex1qiiavqi0xu as isSecure } from '../../../../../ktor-ktor-http/io/ktor/http/URLProtocol.mjs';
import { get_authorityakhc3pgcrb9j as get_authority_0 } from '../../../../../ktor-ktor-http/io/ktor/http/URLBuilder.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Companion_getInstance13wwf84j92s7c as Companion_getInstance_0 } from '../../../../../ktor-ktor-http/io/ktor/http/HttpMethod.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
import { EventDefinition1fymk8xrdelhn as EventDefinition } from '../../../../../ktor-ktor-events/io/ktor/events/Events.mjs';
import { createClientPluginjwpvufjows5r as createClientPlugin } from './api/CreatePluginUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_ALLOWED_FOR_REDIRECT() {
  _init_properties_HttpRedirect_kt__ure7fo();
  return ALLOWED_FOR_REDIRECT;
}
var ALLOWED_FOR_REDIRECT;
function get_LOGGER() {
  _init_properties_HttpRedirect_kt__ure7fo();
  return LOGGER;
}
var LOGGER;
function get_HttpResponseRedirectEvent() {
  _init_properties_HttpRedirect_kt__ure7fo();
  return HttpResponseRedirectEvent;
}
var HttpResponseRedirectEvent;
function get_HttpRedirect() {
  _init_properties_HttpRedirect_kt__ure7fo();
  return HttpRedirect;
}
var HttpRedirect;
var HttpRedirectConfigClass;
function HttpRedirectConfig() {
  if (HttpRedirectConfigClass === VOID) {
    class $ {
      constructor() {
        this.n5q_1 = true;
        this.o5q_1 = false;
      }
    }
    initMetadataForClass($, 'HttpRedirectConfig', HttpRedirectConfig);
    HttpRedirectConfigClass = $;
  }
  return HttpRedirectConfigClass;
}
function isRedirect(_this__u8e3s4) {
  _init_properties_HttpRedirect_kt__ure7fo();
  var tmp0_subject = _this__u8e3s4.d53_1;
  return tmp0_subject === Companion_getInstance().m51_1.d53_1 || tmp0_subject === Companion_getInstance().n51_1.d53_1 || (tmp0_subject === Companion_getInstance().s51_1.d53_1 || (tmp0_subject === Companion_getInstance().t51_1.d53_1 || tmp0_subject === Companion_getInstance().o51_1.d53_1)) ? true : false;
}
function HttpRedirectConfig$_init_$ref_rhym9t() {
  var l = () => new (HttpRedirectConfig())();
  l.callableName = '<init>';
  return l;
}
function HttpRedirect$lambda($this$createClientPlugin) {
  _init_properties_HttpRedirect_kt__ure7fo();
  var checkHttpMethod = $this$createClientPlugin.w5m_1.n5q_1;
  var allowHttpsDowngrade = $this$createClientPlugin.w5m_1.o5q_1;
  var tmp = Send_instance;
  $this$createClientPlugin.z5m(tmp, HttpRedirect$lambda$slambda_0(checkHttpMethod, allowHttpsDowngrade, $this$createClientPlugin));
  return Unit_instance;
}
function *invoke$handleCall(_this__u8e3s4, context, origin, allowHttpsDowngrade, client, $completion) {
  var call = origin;
  var requestBuilder = context;
  while (true) {
    var previousProtocol = call.g5i().p5i().i54_1;
    var previousAuthority = get_authority(call.g5i().p5i());
    if (!isRedirect(call.l5g().w5i()))
      return call;
    var location = call.l5g().f50().m2o('Location');
    if (location == null) {
      get_LOGGER().i4s('Location header missing from redirect response ' + call.g5i().p5i().toString() + '; returning response as is');
      return call;
    }
    client.e5g_1.m4s(get_HttpResponseRedirectEvent(), call.l5g());
    get_LOGGER().k4s('Received redirect response to ' + location + ' for request ' + call.g5i().p5i().toString());
    // Inline function 'kotlin.apply' call
    var this_0 = new (HttpRequestBuilder())();
    this_0.k5l(requestBuilder);
    this_0.p5h_1.s53_1.a5();
    takeFrom(this_0.p5h_1, location);
    if (!allowHttpsDowngrade && isSecure(previousProtocol) && !isSecure(this_0.p5h_1.v53())) {
      get_LOGGER().k4s('Blocked redirect from ' + call.g5i().p5i().toString() + ' to ' + location + ' due to HTTPS downgrade');
      return call;
    }
    if (!(previousAuthority === get_authority_0(this_0.p5h_1))) {
      this_0.r5h_1.q4o('Authorization');
      get_LOGGER().k4s('Removing Authorization header for cross-authority redirect: ' + (previousAuthority + ' -> ' + this_0.p5h_1.f55()));
    }
    requestBuilder = this_0;
    call = yield* _this__u8e3s4.q5p(requestBuilder, $completion);
  }
}
var HttpRedirect$lambda$slambdaClass;
function HttpRedirect$lambda$slambda() {
  if (HttpRedirect$lambda$slambdaClass === VOID) {
    class $ {
      constructor($checkHttpMethod, $allowHttpsDowngrade, $this_createClientPlugin) {
        this.p5q_1 = $checkHttpMethod;
        this.q5q_1 = $allowHttpsDowngrade;
        this.r5q_1 = $this_createClientPlugin;
      }
      *n5p($this$on, request, $completion) {
        var origin = yield* $this$on.q5p(request, $completion);
        if (this.p5q_1 && !get_ALLOWED_FOR_REDIRECT().t2(origin.g5i().o5i())) {
          return origin;
        }
        return yield* /*#__NOINLINE__*/invoke$handleCall($this$on, request, origin, this.q5q_1, this.r5q_1.v5m_1, $completion);
      }
      md(p1, p2, $completion) {
        var tmp = p1 instanceof Sender() ? p1 : THROW_CCE();
        return this.n5p(tmp, p2 instanceof HttpRequestBuilder() ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    HttpRedirect$lambda$slambdaClass = $;
  }
  return HttpRedirect$lambda$slambdaClass;
}
function HttpRedirect$lambda$slambda_0($checkHttpMethod, $allowHttpsDowngrade, $this_createClientPlugin) {
  var i = new (HttpRedirect$lambda$slambda())($checkHttpMethod, $allowHttpsDowngrade, $this_createClientPlugin);
  var l = ($this$on, request, $completion) => i.n5p($this$on, request, $completion);
  l.$arity = 2;
  return l;
}
var properties_initialized_HttpRedirect_kt_klj746;
function _init_properties_HttpRedirect_kt__ure7fo() {
  if (!properties_initialized_HttpRedirect_kt_klj746) {
    properties_initialized_HttpRedirect_kt_klj746 = true;
    ALLOWED_FOR_REDIRECT = setOf([Companion_getInstance_0().g50_1, Companion_getInstance_0().l50_1]);
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.HttpRedirect');
    HttpResponseRedirectEvent = new (EventDefinition())();
    var tmp = HttpRedirectConfig$_init_$ref_rhym9t();
    HttpRedirect = createClientPlugin('HttpRedirect', tmp, HttpRedirect$lambda);
  }
}
//region block: exports
export {
  get_HttpRedirect as get_HttpRedirect1lgx3wewnhrb0,
};
//endregion

//# sourceMappingURL=HttpRedirect.mjs.map
